import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
} from "@react-pdf/renderer";
import axios from "axios";
import { Spin } from "antd";
import moment from "moment";
import config from "../../../config";
import PrintHeaderAccount from "../../../Pdf/PrintHeaderAccount";
import PrintFooter from "../../../Pdf/PrintFooter";
import { saleReportStyles } from "../../../Pdf/pdfStyles";
import { formatReportField } from "../../../Pdf/PrintFormateNumber";

const LABEL_COL = 380;
const VALUE_COL = 187;

const SUMMARY_ROWS = [
  { label: "Opening cash", key: "OpeningCash" },
  { label: "Opening cash at banks", key: "OpeningCashatBanks" },
  { label: "Cash sales", key: "CashSales" },
  { label: "Credit sales", key: "CreditSales" },
  { label: "Cash purchase", key: "CashPurchase" },
  { label: "Credit purchase", key: "CreditPurchase" },
  { label: "Total received (cash vouchers)", key: "TotalReceived", whole: true },
  { label: "Total payments (cash out, excl. expense/discount)", key: "TotalPayments", whole: true },
  { label: "Expense accounts (balance at period end)", key: "TotalExpenses", whole: true },
  { label: "Total discounts (vouchers)", key: "TotalDiscounts", whole: true },
  { label: "Closing cash", key: "ClosingCash" },
  { label: "Closing cash at banks", key: "ClosingCashatBanks" },
];

const PrintSummarySheet = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const StartDate = urlParams.get("StartDate");
  const EndDate = urlParams.get("EndDate");

  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");

  const [summaryDetail, setSummaryDetail] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Print Summary Sheet";
    if (!StartDate || !EndDate || !UserID || !AccessKey) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const data = {
      UserID: String(UserID),
      AccessKey: AccessKey,
      StartDate: moment(StartDate).isValid()
        ? moment(StartDate).format("YYYY-MM-DD")
        : StartDate,
      EndDate: moment(EndDate).isValid()
        ? moment(EndDate).format("YYYY-MM-DD")
        : EndDate,
    };

    axios({
      method: "post",
      url: config.base_url + "Report/GetSummarySheet",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setSummaryDetail(response.data);
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  }, [StartDate, EndDate, UserID, AccessKey]);

  const periodLabel = `${
    StartDate && moment(StartDate).isValid()
      ? moment(StartDate).format(config.date_format)
      : "—"
  } to ${
    EndDate && moment(EndDate).isValid()
      ? moment(EndDate).format(config.date_format)
      : "—"
  }`;

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={saleReportStyles.page}>
        <PrintHeaderAccount compact />
        <View style={saleReportStyles.section}>
          <View style={saleReportStyles.titleBlock}>
            <Text style={saleReportStyles.pagetitle}>Summary Sheet</Text>
            <Text style={saleReportStyles.reportSubtitle}>
              Period: {periodLabel}
            </Text>
          </View>

          <View style={saleReportStyles.table}>
            <View style={saleReportStyles.tableHead}>
              <View style={[saleReportStyles.th, { width: LABEL_COL }]}>
                <Text style={saleReportStyles.thValue}>Description</Text>
              </View>
              <View
                style={[
                  saleReportStyles.th,
                  { width: VALUE_COL, textAlign: "right" },
                ]}
              >
                <Text style={saleReportStyles.thValue}>Amount</Text>
              </View>
            </View>

            {SUMMARY_ROWS.map((row) => (
              <View key={row.key} style={saleReportStyles.row}>
                <View style={[saleReportStyles.td, { width: LABEL_COL }]}>
                  <Text style={saleReportStyles.tdValue}>{row.label}</Text>
                </View>
                <View
                  style={[
                    saleReportStyles.td,
                    { width: VALUE_COL, textAlign: "right" },
                  ]}
                >
                  <Text style={saleReportStyles.tdValue}>
                    {formatReportField(
                      summaryDetail[row.key],
                      row.whole ? 0 : undefined
                    )}
                  </Text>
                </View>
              </View>
            ))}
          </View>

          <View
            style={{ marginBottom: 20, marginTop: 0, top: 6, bottom: 6 }}
            fixed
          >
            <Text
              style={{ fontSize: "7pt", color: "#000" }}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </View>
        <PrintFooter fixed />
      </Page>
    </Document>
  );

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {loading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <PDFViewer width="100%" height="100%" fileName="SummarySheet.pdf">
          <MyDocument />
        </PDFViewer>
      )}
    </div>
  );
};

export default PrintSummarySheet;
